module.exports = __webpack_public_path__ + "img/统一认证(3).47aa5770.png";